import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('dipendenti');
export const actions = helper.createActions('dipendenti', actionTypes);